import dayjs from "dayjs";
import apiClient from "../api/apiClient";
import { FORTRESS_API } from "../api/consts";
import { ISort, ISort2 } from "../interfaces/Sort";
import { removeNulls } from "../utils/helpers";

function _formatSortData(sortData: any, pageSize: number, isNotPrinted = true) {
  const { fromDate, toDate, priceBand, area, event } = sortData;

  const _sort: ISort2 = {
    dates: {
      fromDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : undefined,
      toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : undefined
    },
    price: {
      fromPrice: sortData.fromPrice,
      toPrice: sortData.toPrice,
    },
    eventId: event ? `${event.clubPrefix}_EVENT_${event.eventId}` : undefined,
    area: area ? area?.areaCode : undefined,
    stadium: sortData.stadium,
    priceBand: priceBand && priceBand.priceBandCode ? priceBand.priceBandCode : null,
    page: sortData.page,
    order: [
      [sortData.field, sortData.sort ? sortData.sort.toUpperCase() : "ASC"],
    ],
    showNullDts: sortData.showNullDts ? sortData.showNullDts : 1,
    limit: pageSize,
    distinct: sortData.distinct ? sortData.distinct : 1,
    reverseResults: isNotPrinted ? 1 : 0,
    clubPrefix: sortData.clubPrefix ? sortData.clubPrefix : '',
    searchPhrase: sortData.searchPhrase
  };

  const _sortWithNoNulls = removeNulls(_sort);

  return _sortWithNoNulls;
}

export const reprintRFIDTickets = async (ticketsToPrint: any[], club: any) => {//TODO type ReprintMemberExtendedReq
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/reprintMemberExtended`, {barcodes: ticketsToPrint, club});
    return res;
  } catch (error: any) {
    return error?.message;
  }
};

export const getAllRFIDTicketsNotPrinted = async (sortData: ISort, pageSize: number, isNotPrinted: boolean) => {
  try {  
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllRFIDTicketsNotPrinted`, _formatSortData(sortData, pageSize, isNotPrinted));
    return res.data.data;
  } catch (error: any) {
    console.log("getAllRFIDTicketsNotPrinted error", error);
		return Promise.reject(error);
  }
};

export const getAllRFIDTicketsNotPrintedTotals = async (sortData: ISort) => {
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllRFIDTicketsNotPrintedTotals`, sortData);
    return res.data.data;
  } catch (error: any) {
    return error?.message;
  }
};

export const createAllEventimTicketsAtFortress = async (event: any, club: any) => {
  const eventId = event?.eventId ?? event?._ID;
  const clubPrefix = club?.clubPrefix ?? event?.clubPrefix;

  if (!eventId || !clubPrefix) {
    return Promise.reject(new Error("Missing eventId or clubPrefix"));
  }

  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/createAllEventimTicketsAtFortress`, {
      eventId,
      clubPrefix,
    });
    return res.data.data;
  } catch (error: any) {
    return Promise.reject(error);
  }
};

// export const orderBy = async ({ field, sort, page }: ISort) => {
//   try {
//     const res: any = await apiClient.get(
//       `${FORTRESS_API}?page=${page}&col=${field}&order=${sort.toUpperCase()}`
//     );
//     return Promise.resolve(res);
//   } catch (error: any) {
//     return error?.message;
//   }
// };

export const getAllPriceBandsCodes = async () => {
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllPriceBandsCodes`);
    return res.data.data;
  } catch (error: any) {
    return error?.message;
  }
};

export const getAllEventsByClub = async (clubPrefix: string) => {
  if (!clubPrefix || clubPrefix === "ADMIN") {
    return [];
  }
  
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllEventsByClub`, {clubPrefix});
    return res.data.data;
  } catch (error: any) {
    return error?.message;
  }
};

export const getAllAreaCodes = async () => {
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllAreaCodes`);
    return res.data.data;
  } catch (error: any) {
    return error?.message;
  }
};

export const getAllStadiumsCodes = async () => {
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllStadiumsCodes`);
    return res.data.data;
  } catch (error: any) {
    return error?.message;
  }
};

export const getAllClubsCodes = async () => {
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/getAllClubsCodes`);
    return res.data.data;
  } catch (error: any) {
    console.error(error?.message);
    return []
  }
};

export const getTicketsCompareData = async (club: any, event: any) => {
  try {  
    const res: any = await apiClient.post(`${FORTRESS_API}/getTicketsCompareData`, {club, event});
    return res?.data?.data ? res?.data?.data : {differentObjects: [], evaXMLTicketsLength: 0, fortressTicketsLength: 0};
  } catch (error: any) {
    console.log("getTicketsCompareData error", error);
		return Promise.reject(error);
  }
};

export const renewSeasonAssessment = async (club: any, excelData: any) => {
  try {  
    const res: any = await apiClient.post(`${FORTRESS_API}/renewSeasonAssessment`, {club, excelData});
    return res?.data?.data ? res?.data?.data : {reprintArray: [], responseRenewArray: []};
  } catch (error: any) {
    console.log("renewSeasonAssessment error", error);
		return Promise.reject(error);
  }
};

export const renewReprint = async (club: any, reprintArray: any, responseRenewArray: any) => {
  try {  
    const res: any = await apiClient.post(`${FORTRESS_API}/renewReprint`, {club, reprintArray, responseRenewArray});
    return res?.data?.data;
  } catch (error: any) {
    console.log("renewReprint error", error);
		return Promise.reject(error);
  }
};

export const sendEmailWithEventimAPIByCostumerNumber = async (costumerNumber: number) => {
  try {
    const res: any = await apiClient.post(`${FORTRESS_API}/sendEmailWithEventimAPIByCostumerNumber`, {costumerNumber});
    console.log("sendEmailWithEventimAPIByCostumerNumber res", res);

    if (res.status !== 200) return null;
    return res.data.data;
  } catch (error: any) {
    console.error("Failed to fetch ticket PDF", error);
    return null;
  }
};